import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { doorDashApi } from 'api/doorDash';
import { goPuffApi } from 'api/goPuff';
import { UserContext } from 'contexts/UserContext';
import { UploadCSVAndReviewComponent } from 'shared';

function WholesalePricingUpload() {
    const { wholesaleAccount } = useContext(UserContext);
    const [api, setApi] = useState(wholesaleAccount.fbmAccountName === 'doordash' ? doorDashApi : goPuffApi);

    useEffect(() => {
        if (wholesaleAccount.fbmAccountName === 'doordash') {
            setApi(doorDashApi);
        } else {
            setApi(goPuffApi);
        }
    }, [wholesaleAccount]);

    const columns = [
        { Header: 'External SKU', accessor: 'externalSku' },
        { Header: 'Effective Date', accessor: 'effectiveDate' },
        { Header: 'Each Cost', accessor: 'eachCost' },
        { Header: 'Case Cost', accessor: 'caseCost' },
        { Header: 'Currency', accessor: 'currency' },
        { Header: 'OpCo Name', accessor: 'opCoName' },
        { Header: 'Location ID', accessor: 'locationID' },
        { Header: 'Errors', accessor: 'errors' },
        { Header: 'Warnings', accessor: 'warnings' },
    ];

    const confirmUpload = async (key) => {
        const res = await api.confirmPricingUpload(key);
        return res;
    };

    const uploadRows = async (formData) => {
        const res = await api.uploadPricing(formData);
        return res;
    };

    const downloadTemplate = () => {
        let csvContent = 'data:text/csv;charset=utf-8,External SKU,Effective Date,';
        csvContent += 'Each Cost,Case Cost,Currency,OpCo Name,LocationID';
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', `${wholesaleAccount.fbmAccountName}_pricing_upload_template.csv`);
        document.body.appendChild(link);

        link.click();
    };

    return (
        <div>
            <Link to="/gopuff/pricing">View Pricing</Link>
            <UploadCSVAndReviewComponent
                title={`Upload ${wholesaleAccount.companyName} Pricing`}
                fileLabel="Pricing File"
                columns={columns}
                upload={uploadRows}
                confirm={confirmUpload}
                downloadTemplate={downloadTemplate}
            />
        </div>
    );
}

export { WholesalePricingUpload };
